/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-key */
import React from 'react';
import { Column, useExpanded, useSortBy, useTable } from 'react-table';

interface CoreTableProps {
  data: Array<any>;
  columns: Array<Column>;
  sorted?: boolean;
  id: string;
}

const CoreTable: React.FC<CoreTableProps> = ({
  data,
  columns,
  sorted = false,
  id,
}): JSX.Element => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data, disableSortBy: !sorted }, useSortBy, useExpanded);

  return (
    <table data-testid="testTable" id={id} {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
                className="text-font-200 whitespace-nowrap text-s-12 text-left"
                {...column.getHeaderProps(column.getSortByToggleProps())}
              >
                {column.render('Header')}
                <span className="pl-2">
                  {column.canSort ? (
                    <img
                      className="inline-block"
                      src="https://assets1.cleartax-cdn.com/cleartax/images/1642072523_group18140566.svg"
                      alt="sorting icon"
                      width={10}
                      height={18}
                    />
                  ) : null}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export { CoreTable };
